//libraries
import { initAOS } from './lib/aos';
import { initFancybox } from './lib/fancybox';

// modules scripts
import { initAllScripts } from './modules/script';

// modules sliders
import { initAllSliders } from './modules/sliders';

// modules header
import { initHeader } from './modules/header';
// modules map
import { leafletMap } from './modules/map';

import './modules/modal';

document.addEventListener('DOMContentLoaded', () => {
	initAOS();
	initFancybox();
	initHeader();
	leafletMap();
	initAllScripts();
	initAllSliders();
});
